export default "__VITE_ASSET__CWdu43BA__"